/**
 * a Selector for modal reducer
 * @param {*} state
 */
export const ModalSelector = state => state.modal;